import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { NUMBER } from '../../../constants/app-constants';
import newArray from '../../../utils/helpers/new-array';

const SkeletonLoader = () => {
    const { step } = useParams();
    return (
        <React.Fragment>
            {!step &&
                <React.Fragment >
                    {
                        newArray(NUMBER.TWO).map((item) => (
                            <AuctionCardSkeleton key={item} />
                        ))
                    }
                </React.Fragment>
            }
            {step &&
                <Stack gap={3} className='p-4'>
                    <AuctionCardSkeleton isDetail={true} />
                    <ImageGridSkeleton />
                    <Stack className='border text-light-border p-2 rounded mb-6' gap={1}>
                        <ImageGridSkeleton />
                        <Skeleton variant="rectangular" width={'100%'} height={200} />
                    </Stack>
                    <Stack className='fixed bottom-0 m-4 shadow p-4 left-0 right-0' direction={'row'} gap={2}>
                        {newArray(NUMBER.TWO).map((item) => (
                            <Skeleton key={item} variant="rectangular" width={'50%'} height={36} />
                        ))}
                    </Stack>
                </Stack>
            }
        </React.Fragment>
    );
};

export default SkeletonLoader;

export const AuctionCardSkeleton = ({ isDetail = false }) => {
    return (
        <React.Fragment>
            {!isDetail &&
                <Stack direction={'row'} gap={1}>
                    <Skeleton width="70%" className='mb-3' />
                    <Skeleton width="30%" className='mb-3' />
                </Stack>
            }
            <Box className='border text-light-border p-2 rounded mb-6'>
                <Stack direction={'row'} gap={1}>
                    <Skeleton variant="rectangular" width={isDetail ? '100%' : '75%'} height={200} />
                    {!isDetail && <Skeleton variant="rectangular" width={'25%'} height={200} />}
                </Stack>
                <Stack sx={{ pt: 2 }} gap={1}>
                    <Skeleton width="90%" />
                    <Stack direction={'row'} gap={2} width="90%">
                        {newArray(NUMBER.THREE).map((item) => (
                            <Skeleton key={item} width="30%" />
                        ))}
                    </Stack>
                    <Stack sx={{ py: 1 }} direction={'row'} gap={3}>
                        <Skeleton variant="rectangular" height={36} width="50%" />
                        <Stack direction={'column'} gap={1} width='50%'>
                            {newArray(NUMBER.TWO).map((item) => (
                                <Skeleton key={item} width="100%" />
                            ))}
                        </Stack>
                    </Stack>
                </Stack>
            </Box>
        </React.Fragment>
    );
};

AuctionCardSkeleton.propTypes = {
    isDetail: PropTypes.bool
};

export const ImageGridSkeleton = () => {
    return (
        <Stack direction={'row'} gap={1}>
            {newArray(NUMBER.FIVE).map((item) => (
                <Skeleton key={item} variant="rectangular" width={'20%'} height={36} />
            ))}
        </Stack>
    );
};
